import React, { useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'
import TimelineProvider from '../../../../contexts/TimelineContext'
import TimelineContent from './TimelineParts/TimelineContent'
import { CampaignContext } from '../../../../contexts/CampaignContext'
import CampaignScenario from '../../../../models/CampaignScenario'

export default observer(function ProjectTimeline() {
  const { campaignScenarios } = useContext(CampaignContext)
  const { isCollapsed } = useSidebarCollapse()

  const campaignScenario = useMemo(() => campaignScenarios[0] || new CampaignScenario(), [campaignScenarios.length, campaignScenarios])
  const leftOffset = isCollapsed ? 128 : 222

  return (
    <div
      className="fixed top-[52px] -z-10 h-[calc(100vh-52px)] bg-rb-grey transition-all duration-300 dark:bg-rb-dark-mode-background"
      style={{ left: `${leftOffset}px`, width: `calc(100vw - ${leftOffset}px)` }}
    >
      <TimelineProvider campaignScenario={campaignScenario}>
        <div className="h-full">
          <TimelineContent />
        </div>
      </TimelineProvider>
    </div>
  )
})
